import React from 'react'

// Logo and social icons
import facebook from '../../assets/icons/social/facebook.svg'
import instagram from '../../assets/icons/social/instagram.svg'
import linkedin from '../../assets/icons/social/linkedin.svg'
import twitter from '../../assets/icons/social/twitter.svg'
import logo from '../../assets/logo.svg'
import Nav from '../nav/index.js'

const socialLinks = [
  { href: 'https://facebook.com/taoclimate', icon: facebook, alt: 'Facebook' },
  { href: 'https://x.com/taoclimate', icon: twitter, alt: 'X' },
  { href: 'https://linkedin.com/company/taoclimate', icon: linkedin, alt: 'LinkedIn' },
  { href: 'https://instagram.com/taoclimate', icon: instagram, alt: 'Instagram' }
]

const Footer: React.FC = () => {
  return (
    <footer className="w-full bg-[#002F45] flex flex-col items-center py-8">
      <div className="w-full max-w-[1148px] flex flex-col gap-6">
        {/* Top row: Logo and Nav */}
        <div className="flex flex-row items-start justify-between w-full">
          <img src={logo} alt="Logo" className="h-10 pl-4 md:pl-4 lg:pl-0" />
          <Nav showPolicyLinks={true} />
        </div>
        {/* Divider */}
        <div className="w-full border-t border-[rgba(255,255,255,0.1)]" />
        {/* Social icons row */}
        <div className="flex flex-row justify-center items-center gap-4 mt-2">
          {socialLinks.map(({ href, icon, alt }) => (
            <a
              key={alt}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white hover:bg-[#003B57] transition-colors"
            >
              <img src={icon} alt={alt} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  )
}

export default Footer
